import * as classNames from "classnames";
import * as classnames from "classnames";
import { ReactNode, memo } from "react";
import * as labeledInputCss from "./labeled-input.module.css";
import * as themeCss from "./theme.module.css";

export type LabelTheme =
  | typeof LabelTheme.NORMAL
  | typeof LabelTheme.LIGHT
  | typeof LabelTheme.THIN;

export namespace LabelTheme {
  export const NORMAL = Symbol("Normal");
  export const LIGHT = Symbol("Light");
  export const THIN = Symbol("Thin");
}

export type LabelPosition =
  | typeof LabelPosition.ABOVE
  | typeof LabelPosition.LEFT
  | typeof LabelPosition.RIGHT;

export namespace LabelPosition {
  export const ABOVE = Symbol("above");
  export const LEFT = Symbol("left");
  export const RIGHT = Symbol("right");
}

const labelPositionClass = new Map<LabelPosition, string>();
labelPositionClass.set(LabelPosition.ABOVE, labeledInputCss.vertical);
labelPositionClass.set(LabelPosition.LEFT, labeledInputCss.horizontal);
labelPositionClass.set(LabelPosition.RIGHT, labeledInputCss.horizontal);

export const LabeledInput = memo(
  ({
    label,
    id,
    children,
    description,
    position = LabelPosition.ABOVE,
    errors = [],
    theme = LabelTheme.NORMAL,
  }: {
    id?: string;
    label: ReactNode;
    children: ReactNode;
    description?: ReactNode | ReactNode[];
    position?: LabelPosition;
    theme?: LabelTheme;
    errors?: string[];
  }) => {
    return (
      <div
        className={classnames(
          labeledInputCss.container,
          labelPositionClass.get(position),
          {
            [labeledInputCss.light]: theme === LabelTheme.LIGHT,
            [labeledInputCss.thin]: theme === LabelTheme.THIN,
          },
        )}
      >
        {position === LabelPosition.RIGHT && (
          <>
            {children}
            {description && (
              <div
                className={classNames(
                  labeledInputCss.description,
                  themeCss.description,
                )}
              >
                {description}
              </div>
            )}
            {label && (
              <label className={labeledInputCss.label} htmlFor={id}>
                {label}
              </label>
            )}
          </>
        )}
        {[LabelPosition.LEFT, LabelPosition.ABOVE].includes(position) && (
          <>
            {label && (
              <label className={labeledInputCss.label} htmlFor={id}>
                {label}
              </label>
            )}
            {children}
            {description && (
              <div
                className={classNames(
                  labeledInputCss.description,
                  themeCss.description,
                )}
              >
                {description}
              </div>
            )}
          </>
        )}
        {errors.map((error, index) => (
          <div key={index} className={labeledInputCss.error}>
            {error}
          </div>
        ))}
      </div>
    );
  },
);
